import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { cn } from "../../lib/utils/index.js";

export const SocialMediaEmbedServerside = ({ children, className }: any) => {
  return (
    <NodeViewWrapper className={cn("react-component", className)}>
      <NodeViewContent contentEditable="false" className="socialMediaContainer">
        <div
          style={{ display: "flex", justifyContent: "center" }}
          draggable="false"
          data-drag-handle=""
        >
          {children}
        </div>
      </NodeViewContent>
    </NodeViewWrapper>
  );
};
